import { render, staticRenderFns } from "./binding-pop.vue?vue&type=template&id=49684314&scoped=true&"
import script from "./binding-pop.vue?vue&type=script&lang=js&"
export * from "./binding-pop.vue?vue&type=script&lang=js&"
import style0 from "./binding-pop.vue?vue&type=style&index=0&id=49684314&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49684314",
  null
  
)

export default component.exports